import React, { useEffect, useState } from "react";
import Crest from "./Crest";

const PageLoader = () => {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1300);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className={`num-loader ${done ? "is-done" : ""}`} aria-hidden={done} data-testid="page-loader">
      <div className="text-num-gold animate-crest-fade">
        <Crest size={80} strokeWidth={1.1} />
      </div>
    </div>
  );
};

export default PageLoader;
